import Create from "./Create";
import Update from "./Update";
import showAll from "./showAll";
import Delete from "./Delete"

const FAQ = { Update, showAll,Create,Delete };

export default FAQ;

export {
    Create,
    Update,
    showAll,
    Delete,
}